// extracted by mini-css-extract-plugin
export default {"button":"Button_button__sBx4u","rose":"Button_rose__ED0RI","exit":"Button_exit__MTHuE","cancel":"Button_cancel__cRc5X","disabled":"Button_disabled__SU7lU"};